import BasePresenter from "../../redare/presenter/BasePresenter";
import * as LoginHttp from "../http/LoginHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class LoginPresenter extends BasePresenter {

    /**
     * @param body: {accountId, platform, userPlatform, pwd, needResetPwd}
     * @param query: {}
     * @returns Promise
     */
    modifyPwd(body, query, success, fails) {

        if (this._onBeforeModifyPwd) {
            let data = this._onBeforeModifyPwd(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        LoginHttp.modifyPwd(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeModifyPwdSuccess) {
                    result = this._onBeforeModifyPwdSuccess(result, {body, query});
                }

                if (this.view && this.view._onModifyPwdSuccess) {
                    this.view._onModifyPwdSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

}